import React, { useState, useEffect } from "react";
import Pagination from "../../../../../components/pagination/Pagination";
import { PulseLoader } from "react-spinners";
import PlaceholderEmptyScreen from "../../../../../components/PlaceholderEmptyScreen";
import placeholderImage from "../../../../../assets/img/no-project-template.svg";
import { selectUser } from "../../../../../redux/user/user-selector";
import {
  TriyoButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../../../components/TriyoButton";
import { useHistory } from "react-router-dom";
import GroupRowNew from "../group-row/GroupRowNew";
import GroupsTableHeaderNew from "../groups-table-header/GroupsTableHeaderNew";
import {
  selectSearchGroupsQuery,
  selectGroups,
  selectNumGroups,
  selectIsFetchingGroups,
  selectSelectedGroups,
} from "../../../../../redux/groups/group-selector";
import {
  fetchGroups,
  setSelectedGroups,
} from "../../../../../redux/groups/group-actions";
import { useSelector, useDispatch } from "react-redux";
import AdminDownloadConfirmPopupNew from "../../admin-download-confirm-popup/admin-download-confirm-popup-new";
import AdminActionsPopupNew from "../../admin-actions-popup/AdminActionsPopupNew";

const GroupsTableContainerNew = (props) => {
  const [showAdminActionsPopup, setShowAdminActionsPopup] = useState(false);
  const [showDownloadsPanel, setShowDownloadsPanel] = useState(false);
  const [headerKey, setHeaderKey] = useState(false);
  const [isArchived, setIsArchived] = useState(false);

  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const numEntries = useSelector(selectNumGroups);
  const data = useSelector(selectGroups);
  const selectedRows = useSelector(selectSelectedGroups);
  const searchQuery = useSelector(selectSearchGroupsQuery);
  const loading = useSelector(selectIsFetchingGroups);

  const isSuperAdmin = user?.profile?.isSuperAdminRole;
  const canCreate = user?.privileges.Group.Add;
  const containRecords = data?.length > 0;
  const canArchive = selectedRows.length > 0;
  const canDownload = canCreate && containRecords;
  const isSelfServe =
  window["APP_SETTINGS"].REACT_APP_SELFSERVE_USER === "TRUE";

  useEffect(() => {
    refreshPage();
  }, []);

  const refreshPage = () => {
    setHeaderKey(!headerKey); //Will trigger component remount to reset everything in header to default state
    dispatch(
      fetchGroups({
        pageSize: 10,
        pageNumber: 1,
        sortDesc: false,
        sortBy: "Name",
        filters: [],
      })
    );
    dispatch(setSelectedGroups([]));
  };

  const nextPage = () => {
    const newSearchQuery = {
      ...searchQuery,
      pageNumber: searchQuery.pageNumber + 1,
    };
    dispatch(fetchGroups(newSearchQuery));
  };

  const prevPage = () => {
    const newSearchQuery = {
      ...searchQuery,
      pageNumber: searchQuery.pageNumber - 1,
    };
    searchQuery.pageNumber >= 1 && dispatch(fetchGroups(newSearchQuery));
  };

  const rowChange = (numRows) => {
    dispatch(fetchGroups({ ...searchQuery, pageSize: numRows, pageNumber: 1 }));
  };

  const onArchive = () => {
    if (!user?.privileges.Group.Delete === false) {
      setShowAdminActionsPopup(true);
    }
  };

  const handleArchiveSuccess = () => {
    setIsArchived(true);
  };

  const changeData = (
    filters = searchQuery.filters,
    sortBy = searchQuery.sortBy,
    sortDesc = searchQuery.sortDesc
  ) => {
    dispatch(
      fetchGroups({
        ...searchQuery,
        filters: filters,
        sortBy: sortBy,
        sortDesc: sortDesc,
      })
    );
  };

  const renderRows = () => {
    const Rows =
      data?.map((group) => {
        return (
          <GroupRowNew
            key={group.Id}
            data={group}
            privileges={user?.privileges}
            onArchiveSuccess={handleArchiveSuccess}
          />
        );
      });
    return Rows;
  };

  const onClick = () => {
    history.push("/admin/groups/create");
  };

  const getSelectedName = (groupId) => {
    if (!selectedRows || selectedRows.length <= 0) {
      return "";
    }
    let selectedRow = data.filter((group) => group.Id === groupId);
    return selectedRow[0].Name;
  };

  return (
    <div className="admin-panel-table-container">
      {data ? (
        <React.Fragment>
          <div className="table-control-container">
            <TriyoButton>
              <PrimaryButton
                onClick={onClick}
                disabled={!canCreate}
                text="Create New Group"
              />
              {(isSuperAdmin || !isSelfServe) && (
                <SecondaryButton
                  onClick={() => {
                    setShowDownloadsPanel(true);
                  }}
                  disabled={!canDownload}
                  text="Download Groups"
                />
              )}

              <SecondaryButton
                onClick={(e) => {
                  onArchive();
                  e.preventDefault();
                }}
                disabled={!canArchive}
                text="Archive"
              />
            </TriyoButton>
            {containRecords && (
              <Pagination
                refresh={refreshPage}
                next={nextPage}
                prev={prevPage}
                rowChange={rowChange}
                numEntries={numEntries}
                query={searchQuery}
              />
            )}
          </div>
          <AdminDownloadConfirmPopupNew
            show={showDownloadsPanel}
            onHide={() => setShowDownloadsPanel(false)}
            type={"group"}
            button={"Download"}
          />
          {containRecords && (
            <div className="table-main">
              <table className="table-element">
                <GroupsTableHeaderNew
                  key={headerKey} //Easy way to restart component mounting to reset to default state
                  changeData={changeData}
                  refreshPage={refreshPage}
                  isArchived={isArchived}
                  setIsArchived={setIsArchived}
                />
                {!loading ? (
                  <tbody>{renderRows()}</tbody>
                ) : (
                  <div className="pulse-loader">
                    <PulseLoader></PulseLoader>
                  </div>
                )}
              </table>
            </div>
          )}
          {!containRecords && (
            <PlaceholderEmptyScreen
              headerText="Create a New Group"
              textBeforeLink="Organize your team better with TRIYO. Click the "
              buttonText="Create Group"
              textAfterLink=" button to get started."
              bottomImage={placeholderImage}
              altImageText="Click to create a new group"
              onClick={() => onClick()}
            />
          )}
        </React.Fragment>
      ) : (
        <div className="pulse-loader">
          <PulseLoader></PulseLoader>
        </div>
      )}
      {showAdminActionsPopup && (
        <AdminActionsPopupNew
          type={"group"}
          name={selectedRows.length === 1 && getSelectedName(selectedRows[0])}
          selectedIDs={selectedRows}
          showAdminActionsPopup={showAdminActionsPopup}
          setShowAdminActionsPopup={setShowAdminActionsPopup}
          onArchiveSuccess={handleArchiveSuccess}
        />
      )}
    </div>
  );
};

export default GroupsTableContainerNew;
